import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import logo from '../assets/LOGO_GKM.png';
//import logo from '../assets/fondo.png';
import React, { useEffect, useState } from 'react';
Font.registerHyphenationCallback(word => [word]);

function InformePDF ({ chartImage }) {
    const [statistics, setStatistics] =  useState([]); // 👈 null al inicio
    const [datos,setDatos]=useState([]);
      const [message, setMessage] = useState("");
  // 1. Obtener datos desde backend
  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("https://api.grekad.cfcunap.cl/api/statistics", {
      method: "GET",
      headers: { Authorization: token },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setStatistics(data.statistics); // 👈 guardamos datos
          setDatos(data.statistics[0]); // 👈 guardamos datos
        } else {
          setMessage(data.message || "Error al obtener estadísticas.");
        }
      })
      .catch(() => {
        setMessage("Error en la conexión al servidor.");
      });
  }, []);
return (
  <Document>
      <Page size={[595, 935]} style={styles.page}>
         <View style={styles.watermarkContainer}>
        {Array.from({ length: 5 }).map((_, row) =>
          Array.from({ length: 3 }).map((_, col) => (
            <Image
              key={`${row}-${col}`}
              src={logo}
              style={{
                position: "absolute",
                top: `${row * 30}%`,
                left: `${col * 30}%`,
                width: "25%",
                opacity: 0.08,
              }}
            />
          ))
        )}
        </View>
        {/*<Image src={logo} style={styles.watermark}/>*/}
        {/* Título */}
        <View style={styles.section}>
          <Text style={styles.title}>Informe Técnico - Reconocimiento "Trabajador Destacado 2025"</Text>
          <Text style={styles.text}>
            En cumplimiento de las políticas internas de reconocimiento y fomento de la excelencia laboral, la empresa Grekad Met Ltda. llevó a cabo el proceso de votación correspondiente a la distinción ‘Trabajador Destacado 2025’. El objetivo de esta instancia es destacar a aquellos colaboradores que, durante el periodo evaluado, demostraron un desempeño sobresaliente, compromiso organizacional y contribución significativa a las metas corporativas.
          </Text>
        </View>

        {/* Metodología */}
        <View style={styles.section}>
          <Text style={styles.subtitle}>Metodología del proceso</Text>
          <Text style={styles.text}>
            La elección se efectuó mediante votación directa, en la que participaron todos los trabajadores 
            habilitados de la organización. El padrón total estuvo compuesto por {datos.total_personas_participantes} colaboradores, 
            de los cuales {datos.total_personas_votantes} emitieron su voto, voto, lo que representa una tasa de
participación del {datos.porcentaje_participacion}%.
          </Text>
        </View>

        {/* Resultados */}
        <View style={styles.section}>
          <Text style={styles.subtitle}>Resultados Generales</Text>
          <Text style={styles.text}>
            Se obtuvo un total de {datos.total_personas_votantes} votos válidamente emitidos sobre un universo de {datos.total_personas_participantes} colaboradores.  El gráfico siguiente refleja la tasa de participación en relación al total de
trabajadores.
          </Text>
        </View>
        {/* Gráfico */}
        <View style={styles.section}>
          <Text style={styles.subtitle}>Gráfico de Participación</Text>
          {/*chartImage && <Image src={chartImage} style={styles.chart} />*/}
          {chartImage ? (
          <Image src={chartImage} style={styles.chart} />
        ) : (
          <Text>Esperando gráfico...</Text>
        )}
        </View>
        {/* Ranking */}
        <View style={styles.section}>
          <Text style={styles.subtitle}>Ranking de los 10 Primeros Lugares</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableCellHeader}>Posición</Text>
              <Text style={styles.tableCellHeaderNombre}>Trabajador</Text>
              <Text style={styles.tableCellHeader}>Votos</Text>
              <Text style={styles.tableCellHeader}>Porcentaje</Text>
            </View>
          {statistics.length>0?statistics.map((ranking, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={styles.tableCell}>{index+1}</Text>
              <Text style={styles.tableCellNombre}>{ranking.nombre.toUpperCase()}</Text>
              <Text style={styles.tableCell}>{ranking.total_votos}</Text>
              <Text style={styles.tableCell}>{ranking.porcentaje}%</Text>
            </View>
            )): 
            <View style={styles.tableRow}>
              <Text style={styles.tableCell}></Text>
              <Text style={styles.tableCell}></Text>
              <Text style={styles.tableCell}></Text>
              <Text style={styles.tableCell}></Text>
            </View>
            }
          </View>
        </View>

        {/* Conclusiones */}
        <View style={styles.section}>
          <Text style={styles.subtitle}>Conclusiones</Text>
          <Text style={styles.text}>
            El proceso de selección permitió identificar y reconocer a los colaboradores que han generado 
            un impacto positivo y tangible en la empresa durante el año 2025.  La participación alcanzada, aunque significativa, evidencia un margen de mejora para futuras convocatorias, incentivando la implicación de un mayor número de trabajadores.
Se recomienda implementar estrategias de comunicación interna y actividades de sensibilización que promuevan la importancia de este tipo de reconocimientos, fortaleciendo así la cultura organizacional.
          </Text>
        </View>
      </Page>
    </Document>
    );
}

export default InformePDF;

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, fontFamily: "Times-Roman" },
  section: { marginBottom: 15 },
  title: { fontSize: 18, textAlign: "center", marginBottom: 10, fontWeight: "bold", color: "#2E86C1" },
  subtitle: { fontSize: 14, marginBottom: 6, fontWeight: "bold",color: "#2874A6" },
  text: { marginBottom: 4, textAlign: "justify" },
  table: { display: "table", width: "auto", marginTop: 5 },
  tableRow: { flexDirection: "row" },
  tableCellHeader: { width: "15%", fontWeight: "bold", borderBottom: 1, padding: 4 },
  tableCellHeaderNombre: { width: "70%", fontWeight: "bold", borderBottom: 1, padding: 4 },
  tableCell: { width: "15%", padding: 4 },
  tableCellNombre: {width: '70%', padding: 4 },
  watermark: {
    position: "absolute",
    top: "35%",       // posición vertical
    left: "20%",      // posición horizontal
    width: "60%",     // ancho de la imagen
    opacity: 0.1,     // transparencia
  },
  watermarkContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  chart: { width: 200, height: 200, margin: "0 auto" }
});
